import { getStore, removeStore, setStore } from "@/util/store";
import { foodmacOrderv2ShopGoodsManagePage } from "@/api/hb-shop-operate/eCoinMall";
import { deepClone } from "@/util";
const eCoinMall = {
    state: {
      // 鳄币商城列表数据
      eCoinMallTableData:[],
      // 总数
      eCoinMallTableDataTotalElements:undefined,
      // 选择的要排序的
      chooseECoinMallTableData:[],
    },
    actions: {
       setECoinMallTableData({ commit }, data){
        return new Promise((resolve, reject) => {
            foodmacOrderv2ShopGoodsManagePage(data)
              .then((response) => {
                let dataRes = response.data.data;
                console.log(dataRes);
                dataRes = response.data.data
                commit("SET_ECOINMALLTABLEDATA", dataRes);
                resolve();
              })
              .catch((error) => {
                reject(error);
              });
          });
      },
      setChooseECoinMallTableData({ commit }, data){ 
        commit("SET_CHOOSEECOINMALLTABLEDATA", data);
      },
    },
    mutations: {
      SET_ECOINMALLTABLEDATA: (state, eCoinMallTableData) => {   
        state.eCoinMallTableData = eCoinMallTableData.content
        state.eCoinMallTableDataTotalElements = eCoinMallTableData.totalElements
      },
      SET_CHOOSEECOINMALLTABLEDATA:(state, chooseECoinMallTableData)=>{
        state.chooseECoinMallTableData = deepClone(chooseECoinMallTableData)
      }
    }
  };
  export default eCoinMall